import {Component} from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';

import {omit} from '-/util/lodash';

class DateInput extends Component {
    componentWillReceiveProps(nextProps) {
        const {value} = nextProps;
        if (value !== this.props.value) {
            this.setState({
                value
            });
        }
    }

    static defaultProps = {
        placeholder: '02/25/1985',
        onChange: () => {},
        futureOnly: false
    };

    static propTypes = {
        placeholder: PropTypes.string,
        onChange: PropTypes.func,
        futureOnly: PropTypes.bool
    };

    constructor(props) {
        super(props);
        const {value = ''} = props;
        this.state = {value};
    }

    onChange(e) {
        const value = e.target.value.replace(/[^0-9|\/]/g, '');
        if (value.length <= 10) {
            this.props.onChange(value);
            this.setState({value});
        }
    }

    get value() {
        return this.state.value;
    }

    onKeyDown(e) {
        const {
            keyCode,
            target: {
                value
            }
        } = e;

        const char = String.fromCharCode(keyCode);
        const lastSeparatorIndex = value.lastIndexOf('/');
        if (lastSeparatorIndex !== -1) {
            if (e.keyCode === 8 && lastSeparatorIndex + 1 === value.length) {
                e.preventDefault();
                this.setState({
                    value: value.substr(0, lastSeparatorIndex - 1)
                });
            }
        }

        if (keyCode === 189 || char === '/') {
            e.preventDefault();
        }
    }

    prepForDisplay(value) {
        if (typeof value === 'string') {
            if (value.length === 2 || value.length === 5) {
                value += '/';
            }

            return value.slice(0, 10);
        } else {
            return '';
        }

    }

    getErrors(label = '') {
        const {value} = this.state;
        const {futureOnly} = this.props;

        if (!value) {
            return [`${label} is empty`];
        } else if (futureOnly) {
            const today = moment();
            const date = moment(value);

            if (!date.isAfter(today)) {
                return [`${label} must be a future date`];
            }
        }
        return [];
    }

    render() {
        const inputProps = omit(this.props, ['futureOnly']);

        return (
            <input
                className="date-input"
                type="tel"
                {...inputProps}
                onChange={this.onChange.bind(this)}
                onKeyDown={this.onKeyDown.bind(this)}
                value={this.prepForDisplay(this.state.value)} />
        );
    }
}

export default DateInput;
